const { sumBy, uniq, mapValues, range, pickBy, findKey, sortBy, isEmpty, } = require('lodash');

const { entries } = Object;

const behaviors = {
  variable: {
    label: '変動費',
  },
  fixed: {
    label: '固定費',
  },
};

const types = {
  personnel: {
    label: '人件費',
  },
  outsourcing: {
    label: '外注費',
  },
  supply: {
    label: '消耗品',
  },
  communication: {
    label: '通信費',
  },
  tax: {
    label: '税金',
  },
  system: {
    label: 'システム費',
  },
  advertising: {
    label: '広告費',
  },
  travelAndTransportation: {
    label: '旅費交通費',
  },
  other: {
    label: 'その他',
  },
};

const ownerTypes = {
  seller: {
    label: 'Amazonセラー',
  },
  shop: {
    // 楽天・Shopify など mall 系の店舗を指す。モールが増えたため中立な表記にしている
    label: 'ショップ',
    // 旧ラベル。過去にエクスポートしたCSVを読み込めるよう互換のために残す
    legacyLabels: ['楽天ショップ'],
  },
};

const fields = ({ sellers, shops = [], }) => {
  return {
    ownerType: {
      type: 'select',
      label: '種別',
      options: entries(ownerTypes).map(([k, v]) => ({ label: v.label, value: k })),
      validations: {
        required: v => v != null,
      },
    },
    ownerId: {
      type: 'select',
      label: 'ショップ',
      options: ({ ownerType }) => (
        ownerType === 'shop'
          ? shops.map(_ => ({ label: _.name, value: _.id }))
          : sellers.map(_ => ({ label: _.name, value: _.id }))
      ),
      validations: {
        required: v => v != null,
      },
    },
    behavior: {
      type: 'select',
      label: '区分',
      options: entries(behaviors).map(([k, v]) => ({ label: v.label, value: k })),
      validations: {
        required: v => v != null,
      },
    },
    type: {
      type: 'select',
      label: '費目',
      options: entries(types).map(([k, v]) => ({ label: v.label, value: k })),
      validations: {
        required: v => v != null,
      },
    },
    description: {
      type: 'string',
      label: '内容',
      validations: {
        required: v => v != null,
      },
    },
    amount: {
      type: 'integer',
      label: '金額(税込)',
      validations: {
        required: v => v != null,
        greaterThan0: v => v == null || v > 0,
      },
    },
  };
};

exports.behaviors = behaviors;
exports.types = types;
exports.ownerTypes = ownerTypes;
exports.fields = fields;
